var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"error-bar fade-in mb-2"},[_vm._v(" "+_vm._s(_vm.error)+" "),_c('FontAwesomeIcon',{staticClass:"close-error",attrs:{"icon":_vm.closeIcon},on:{"click":_vm.closeMe}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }